import {getBedsAvailableService, getBedsService} from '../features/bed/services'
import {getMasterModuleService} from '../features/modules/services'

export const useBed = () => {
  const getTypeBeds = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoCama',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getBeds = async (filter: any) => {
    try {
      const {data: response} = await getBedsService({
        pageNumber: 1,
        size: 1000,
        ...filter,
      })
      const mappedRooms = response?.data?.map((item) => ({
        value: item.Id,
        label: item.Codigo,
        ...item,
      }))
      return mappedRooms
    } catch (error) {
      return []
    }
  }

  const getBedsAvailable = async (filter: any) => {
    try {
      const {data: response} = await getBedsAvailableService({
        ...filter,
      })
      const mappedRooms = response?.data?.map((item) => ({
        value: item.Id,
        label: item.Codigo,
        ...item,
      }))
      return mappedRooms
    } catch (error) {
      return []
    }
  }

  const getStatusBed = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoCama',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      return mappedModuleTypes
    } catch (error) {
      console.log(error)
      return []
    }
  }

  const getSubStatusBed = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'SubEstadoCama',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      return mappedModuleTypes
    } catch (error) {
      console.log(error)
      return []
    }
  }

  return {
    getBeds,
    getTypeBeds,
    getStatusBed,
    getSubStatusBed,
    getBedsAvailable,
  }
}
